import React, { useCallback, useEffect, useState } from "react";
import Chip from "src/components/common/Chip";
import Button from "src/components/common/Button";
import List from "../common/List";
import ComItem from "./ComItem";
import GroupItem from "./GroupItem";
import Pagination from "../common/Pagination";
import styled from "styled-components";
import BottomModal, { RefProps } from "../common/BottomModal";
import SearchSortItem from "../filter/SearchSortItem";
import SearchStoreFilerItem from "../filter/SearchStoreFilterItem";
import { useSelectCompanyQuery } from "src/api/userAPI";
import setQueryStringVer from "src/utils/reuseQueryString";
import PaginationCommon from "../common/PaginationCommon";
import { useAppSelector } from "src/store/actions/action";
import { useNavigate } from "react-router-dom";
import vi from "date-fns/esm/locale/vi/index.js";
import { isEmpty } from "lodash";

// const globalDateType = {
//   title: "기간",
//   chip: ["1개월", "3개월", "6개월", "12개월", "기간선택"],
//   check: [false, false, false, false, false],
// };
interface propsData {
  contents?: string | any;
  parentFunc?: any;
}

const ManageComPanel = (props: propsData) => {
  const sortModalRef = React.useRef<RefProps>(null);
  const filterModalRef = React.useRef<RefProps>(null);

  // 정렬모달
  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);

  // 필터모달
  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
  }, []);

  // ++++++++++++++++++++++++++++++++++++++++ 퍼블영역 끝 ++++++++++++++++++++++++++++++++++++++++

  // 뒤로가기에서 필터를 유지하기 위한 sessionStorage
  const sessionStoragePage = window.sessionStorage.getItem("cPage");
  const sessionStorageContents = window.sessionStorage.getItem("cContents");

  const sessionStorageSort = window.sessionStorage.getItem("sSortName");
  const sessionStorageSortIdx = window.sessionStorage.getItem("sSortIdx");

  // const sessionStorageAfter = window.sessionStorage.getItem("cAfter");
  // const sessionStorageInit = window.sessionStorage.getItem("cInit");

  const navigate = useNavigate();

  //=========================================================================================================
  // ========================================== 초기 값 세팅 영역 ==========================================
  // =========================================================================================================
  // const reduceSearchStartDate = useAppSelector((state) => state.asReduce.searchStartDate);
  // const reduceSearchEndDate = useAppSelector((state) => state.asReduce.searchEndDate);

  // const [searchStartDate, setSearchStartDate] = useState<string>("");
  // const [searchEndDate, setSearchEndDate] = useState<string>("");

  const [api, setApi] = useState({
    apiSkip: true,
    filterData: "",
  });
  const { apiSkip, filterData } = api;

  const [view, setView] = useState({
    rerender: false,
    totalPages: 0,
  });

  const { rerender, totalPages } = view;

  // const [init, setInit] = useState({
  //   typeFilter: "",
  //   sortFilter: "",
  //   dateType: { ...globalDateType },
  //   selectedChips: [],
  // });

  // const {  dateType, selectedChips } = init;

  // const [after, setAfter] = useState({
  //   afterDateType: { ...globalDateType },
  //   afterSelectedChips: [],
  // });

  // const { afterDateType, afterSelectedChips } = after;

  // const [page, setPage] = useState(1);

  const [currentPage, setCurrentPage] = useState<number | any>(1);

  const [sortName, setSortName] = useState<string>("최신순");
  const [sortIdx, setSordIdx] = useState<number>(0);

  const [queryString, setQueryString] = useState({
    // typeSearchArray: selectedChips,
    contentsSearchString: "",
    sortSearchString: "최신순",
    pageSearchNumber: 0,
  });

  //=========================================================================================================
  // ========================================== API 영역 ==========================================
  // =========================================================================================================
  const companyListAPI = useSelectCompanyQuery(filterData, { skip: apiSkip });

  //=========================================================================================================
  // ========================================== hook 영역 ==========================================
  // =========================================================================================================

  useEffect(() => {
    return () => {
      const path = location.pathname;
      if (path !== "/manage-list") {
        window.sessionStorage.setItem("cPage", String(currentPage));
        window.sessionStorage.setItem("cContents", props.contents!);

        window.sessionStorage.setItem("sSortName", String(sortName));
        window.sessionStorage.setItem("sSortIdx", String(sortIdx));

        window.sessionStorage.setItem("openTab", "1");
      }
    };
  });

  useEffect(() => {
    setApi({
      ...api,
      apiSkip: false,
    });
  }, []);

  useEffect(() => {
    if (companyListAPI.isSuccess) {
      setCurrentPage(companyListAPI.data.meta.currentPage);
      setView({
        ...view,
        totalPages: companyListAPI.data.meta.totalPages,
      });
    }
  }, [companyListAPI]);

  // useEffect(() => {
  //   setQueryString({
  //     ...queryString,
  //     pageSearchNumber: page,
  //   });
  // }, [page]);

  useEffect(() => {
    if (!sessionStoragePage && !sessionStorageContents && !sessionStorageSort) {
      setQueryString({
        ...queryString,
        contentsSearchString: props.contents,
      });
    }
  }, [props]);

  useEffect(() => {
    // const searchFilter = setQueryStringVer(queryString, searchStartDate, searchEndDate);
    const searchFilter = setQueryStringVer(queryString);
    setApi({
      ...api,
      filterData: searchFilter,
      apiSkip: false,
    });
  }, [queryString]);

  useEffect(() => {
    if (
      (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined && sessionStoragePage !== "1") ||
      (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") ||
      (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined && sessionStorageSort !== "최신순")
    ) {
      let tempPage: any = 1;
      let tempSortName: any = "";
      let tempContents: any = "";
      if (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined) {
        tempPage = sessionStoragePage;
      }
      if (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined) {
        tempSortName = sessionStorageSort;
        setSortName(sessionStorageSort!);
        setSordIdx(Number(sessionStorageSortIdx));
      }
      if (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") {
        tempContents = sessionStorageContents;
        if (props.parentFunc) {
          props.parentFunc(tempContents);
        }
      }
      setQueryString({
        ...queryString,
        pageSearchNumber: Number(tempPage),
        contentsSearchString: tempContents,
        sortSearchString: tempSortName,
      });
    }
    const sessionTime = setTimeout(() => {
      window.sessionStorage.removeItem("cPage");
      window.sessionStorage.removeItem("cContents");
      window.sessionStorage.removeItem("sSortName");
      window.sessionStorage.removeItem("sSortIdx");
      window.sessionStorage.removeItem("openTab");
    }, 500);

    return () => clearTimeout(sessionTime);
  }, [sessionStoragePage, sessionStorageContents, sessionStorageSort]);

  // useEffect(() => {
  //   // if (!sessionStoragePage && !sessionStorageContents && !sessionStorageAfter) {
  //   if (afterSelectedChips.length > 0) {
  //     setQueryString({
  //       ...queryString,
  //       typeSearchArray: afterSelectedChips,
  //       pageSearchNumber: 1,
  //     });
  //     setCurrentPage(1);
  //   }
  //   // }
  // }, [afterSelectedChips]);

  // 날짜 기간 검색을 위한 리듀서
  // useEffect(() => {
  //   if (reduceSearchStartDate && reduceSearchStartDate) {
  //     setSearchStartDate(reduceSearchStartDate!);
  //     setSearchEndDate(reduceSearchEndDate!);
  //   }
  // }, [reduceSearchStartDate, reduceSearchEndDate]);

  //=========================================================================================================
  // ========================================== 이벤트 영역 ==========================================
  // =========================================================================================================

  // 적용하기
  // const confirmBtn = () => {
  //   setAfter({
  //     ...after,
  //     afterDateType: dateType,
  //     afterSelectedChips: selectedChips,
  //   });

  //   if (filterModalRef.current) filterModalRef.current.modalClose();
  //   // const searchFilter = setQueryStringVer(queryString);
  //   // setApi({
  //   //   ...api,
  //   //   filterData: searchFilter,
  //   //   apiSkip: false,
  //   // });
  // };

  // const closeBtn = () => {
  //   setInit({
  //     ...init,
  //     dateType: { ...afterDateType },
  //     selectedChips: [...afterSelectedChips],
  //   });
  // };

  // const initBtn = () => {
  //   setQueryString({
  //     ...queryString,
  //     typeSearchArray: [],
  //     contentsSearchString: "",
  //     sortSearchString: "",
  //     pageSearchNumber: 0,
  //   });
  //   setInit((prev) => ({
  //     ...prev,
  //     dateType: { ...globalDateType },
  //     selectedChips: [],
  //   }));
  // };

  // const deleteSelectChips = (value: string, idx: number) => {
  //   // 자식영역(props)의 선택된 검색어 삭제
  //   const deleteSelect = selectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);

  //   dateType.chip.map((dateValue: any, selectIdx: number) => {
  //     if (dateValue === value) {
  //       dateType.check[selectIdx] = false;
  //     }
  //   });

  //   setInit({
  //     ...init,
  //     selectedChips: deleteSelect,
  //   });

  //   setQueryString({
  //     ...queryString,
  //     typeSearchArray: deleteSelect,
  //   });

  //   // 부모영역(현재)의 선택된 검색어 삭제
  //   const deleteAfterSelect = afterSelectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);
  //   setAfter({
  //     ...after,
  //     afterSelectedChips: deleteAfterSelect,
  //   });
  // };

  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    setSortName(sortName);
    setQueryString({
      ...queryString,
      sortSearchString: sortName,
      pageSearchNumber: 1,
    });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };

  // 자식영역으로 넘겨주는 함수 (page 값 받아오기)
  const objectChange = (currentPage: number) => {
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });

    setCurrentPage(currentPage);
  };

  const childrenSortIdxFunc = (idx: number) => {
    setSordIdx(idx);
  };

  const goProfileDetail = (userId: string) => {
    //
    // window.sessionStorage.setItem("cPage", String(currentPage));
    // window.sessionStorage.setItem("cContents", props.contents!);

    // window.sessionStorage.setItem("sSortName", String(sortName));
    // window.sessionStorage.setItem("sSortIdx", String(sortIdx));

    // window.sessionStorage.setItem("openTab", "1");
    // window.sessionStorage.setItem("cAfter", JSON.stringify(after));
    // window.sessionStorage.setItem("cInit", JSON.stringify(init));

    navigate("/profile/" + userId);
  };

  return (
    <>
      {/* <FilterBtnSet> */}
      {/* <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
          {sortName}
        </Button> */}
      {/* 추후 업체 등록일이 생기면 추가 */}
      {/* <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
          유형전체
        </Button> */}
      {/* {afterSelectedChips?.map((v, idx) => {
          return (
            <Chip
              variant="contained"
              deleted={true}
              key={idx}
              // onDelete={() => deleteSelectChips(v, idx)}
            >
              {v}
            </Chip>
          );
        })} */}
      {/* </FilterBtnSet> */}

      {/* <GroupItem /> */}

      <List pd="0 15px" itemPd="25px 0">
        {companyListAPI.isSuccess && companyListAPI.data.data.length > 0 ? (
          <ComItem data={companyListAPI.isSuccess ? companyListAPI : ""} profileDetailClick={(userId: string) => goProfileDetail(userId)} />
        ) : (
          <NoResult>리스트 결과가 없습니다.</NoResult>
        )}
      </List>

      {/* <BottomModal
        ref={filterModalRef}
        onClick={() => initBtn()}
        onClick2={() => confirmBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용하기"
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchStoreFilerItem dateType={dateType} selectedChips={selectedChips} />
        </List>
      </BottomModal> */}

      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem sortData={["최신순", "오래된순", "가나다순"]} initIdx={sortIdx} onClick={(e) => sortBtn(e)} parentSortIdxFunc={childrenSortIdxFunc} />
        </List>
      </BottomModal>

      {totalPages > 1 && (
        <PaginationCommon
          item_count={10}
          current_page={currentPage}
          total_page={totalPages}
          objectChange={objectChange}
          onClick={() => setView({ ...view, rerender: rerender ? false : true })}
          viewName="manageList"
        />
      )}
    </>
  );
};

const FilterBtnSet = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0 15px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default ManageComPanel;
